import { useState } from 'react';

import { Eye, EyeOff } from 'lucide-react';

import { Input } from '#/components/ui';

const PasswordField = ({
    id,
    name,
    value,
    onChange,
    className = 'w-full px-4 py-3 border border-borderGray rounded-lg shadow-sm placeholder-gray400',
    placeholder = '••••••••',
    ...props
}) => {
    const [showPassword, setShowPassword] = useState(false);

    const toggleVisibility = () => setShowPassword(prev => !prev);

    return (
        <div className='relative'>
            <Input
                id={id}
                name={name}
                type={showPassword ? 'text' : 'password'}
                className={className}
                placeholder={placeholder}
                value={value}
                onChange={onChange}
                {...props}
            />
            <button
                type='button'
                onClick={toggleVisibility}
                className='absolute inset-y-0 right-3 flex items-center text-gray500 hover:text-gray700'
                tabIndex={-1}
            >
                {showPassword ? <Eye size={18} /> : <EyeOff size={18} />}
            </button>
        </div>
    );
};

export { PasswordField };
